// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_YvW","cls2":"SingleClaimPage-cls2_BlJ SingleClaimPage-cls1_YvW"};